import React from 'react';
import { ButtonCTA } from '../components/ButtonCTA';
import { FAQAccordion } from '../components/FAQAccordion';
import { CountdownTimer } from '../components/CountdownTimer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { CheckCircle2, Star, Clock, ShieldCheck, Sparkles, Moon, BookOpen, Heart, Activity, ArrowDown, Gift, Zap, Brain, Coffee, Leaf, Flame, Lock, Download, Award, Users, TrendingUp } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-sand-50 font-sans text-earth-900 selection:bg-terracotta-100 selection:text-terracotta-700 overflow-x-hidden" data-id="element-36">
      {/* 1. Sticky Announcement Bar with Countdown - reverted */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-terracotta-700 via-terracotta-600 to-terracotta-700 text-white py-2.5 px-4 text-center shadow-lg border-b-2 border-gold-500" data-id="element-37">
        <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap text-sm sm:text-base" data-id="element-38">
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-39" />
          <span className="font-bold tracking-wide" data-id="element-40">82% OFF — Termina en:</span>
          <CountdownTimer variant="bar" data-id="element-41" />
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-42" />
        </div>
      </div>

      {/* Scarcity Bar */}
      <div className="bg-earth-900 text-sand-50 py-2 px-4 text-center text-xs sm:text-sm" data-id="element-43">
        <span className="inline-flex items-center gap-2 flex-wrap justify-center" data-id="element-44">
          <Users className="w-4 h-4 text-gold-500" data-id="element-45" />
          <span data-id="element-46">
            <span className="font-bold text-gold-500" data-id="element-47">347 personas</span> están
            viendo esta página ahora
          </span>
          <span className="hidden sm:inline text-earth-600" data-id="element-48">•</span>
          <span data-id="element-49">
            <span className="font-bold text-gold-500" data-id="element-50">+2.000 personas</span> ya
            lo compraron
          </span>
        </span>
      </div>

      {/* 2. Hero Section — single column, no bundle visual */}
      <section className="relative pt-10 pb-16 lg:pt-16 lg:pb-24 px-4 overflow-hidden" data-id="element-51">
        {/* Background blurs */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-52">
          <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-blush-100/70 blur-3xl" data-id="element-53"></div>
          <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-sage-100/60 blur-3xl" data-id="element-54"></div>
          <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] rounded-full bg-gold-500/10 blur-3xl" data-id="element-55"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
          <div className="space-y-6 relative z-10" data-id="element-57">
            {/* Refined gold ribbon badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-gold-500/20 via-gold-500/30 to-gold-500/20 border border-gold-500/40 text-earth-900 text-xs sm:text-sm font-bold tracking-[0.15em] uppercase" data-id="element-58">
              <Sparkles className="w-3.5 h-3.5 text-gold-500" data-id="element-59" />
              Bienestar Natural · Argentina
              <Sparkles className="w-3.5 h-3.5 text-gold-500" data-id="element-60" />
            </div>

            {/* Captivating italic eyebrow */}
            <p className="font-serif italic text-xl sm:text-2xl text-terracotta-700 leading-snug" data-id="element-61">
              Imaginá despertarte mañana sin ese dolor de cuello, sin la
              mandíbula apretada, sin esa pesadez en el cuerpo…
            </p>

            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-serif font-bold leading-[1.1] text-earth-900 tracking-tight" data-id="element-62">
              El sistema natural para
              <span className="relative inline-block mx-1" data-id="element-63">
                <span className="relative z-10" data-id="element-64">aliviar</span>
                <span className="absolute bottom-1 left-0 right-0 h-3 bg-gold-500/40 -z-0 rounded" data-id="element-65"></span>
              </span>
              tu cuerpo, calmar tu mente y volver a sentirte vos.
            </h1>

            <p className="text-base sm:text-lg text-earth-700 leading-relaxed" data-id="element-66">
              Con el bundle completo de{' '}
              <strong data-id="element-67">Auriculoterapia + Reflexología</strong> aprendés
              exactamente qué puntos tocar — sin agujas, sin turnos, sin médicos
              — para empezar a aliviar:
            </p>

            <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-earth-800 text-sm sm:text-base" data-id="element-68">
              {['Migrañas', 'Dolor cervical', 'Contracturas', 'Insomnio', 'Ansiedad física', 'Estrés acumulado', 'Cansancio crónico', 'Tensión corporal'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-69">
                  <CheckCircle2 className="w-4 h-4 text-sage-500 flex-shrink-0" data-id="element-70" />
                  <span data-id="element-71">{item}</span>
                </li>)}
            </ul>

            <div className="pt-2 space-y-4" data-id="element-72">
              <ButtonCTA text="QUIERO EMPEZAR HOY" subtext="Acceso inmediato · Garantía 7 días" showGuarantee data-id="element-73" />

              {/* Trust row */}
              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-earth-700" data-id="element-74">
                <div className="flex items-center gap-1.5" data-id="element-75">
                  <div className="flex text-gold-500" data-id="element-76">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-77" />)}
                  </div>
                  <span className="font-semibold" data-id="element-78">4.9/5</span>
                </div>
                <span className="text-earth-400" data-id="element-79">·</span>
                <div className="flex items-center gap-1.5" data-id="element-80">
                  <Users className="w-4 h-4 text-sage-600" data-id="element-81" />
                  <span data-id="element-82">
                    <strong data-id="element-83">+2.000</strong> personas ya lo usan
                  </span>
                </div>
              </div>

              {/* Hero countdown — slimmer, elegant */}
              <div className="bg-earth-900 rounded-2xl p-4 text-center max-w-md border border-gold-500/30" data-id="element-84">
                <p className="text-gold-500 text-xs font-bold uppercase tracking-[0.15em] mb-2 flex items-center justify-center gap-2" data-id="element-85">
                  <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-86" /> La oferta
                  termina en
                </p>
                <CountdownTimer data-id="element-87" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Problem Section — calm version, no cost-of-inaction block */}
      <section className="py-20 bg-earth-900 text-sand-50 px-4 relative overflow-hidden" data-id="element-88">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-terracotta-900/40 via-transparent to-transparent pointer-events-none" data-id="element-89"></div>

        <div className="max-w-4xl mx-auto text-center space-y-12 relative z-10" data-id="element-90">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-terracotta-100" data-id="element-91">
            ¿Te duele el cuerpo todo el tiempo?
          </h2>

          <div className="flex flex-wrap justify-center gap-3 sm:gap-4" data-id="element-92">
            {['Dolor de cabeza', 'Cuello duro', 'Espalda tensionada', 'Mandíbula apretada', 'Migrañas', 'Insomnio', 'Agotamiento constante'].map((symptom, i) => <span key={i} className="px-4 py-2 rounded-full bg-earth-800/50 border border-earth-700 text-sand-100 font-medium" data-id="element-93">
                {symptom}
              </span>)}
          </div>

          <div className="space-y-6 text-xl sm:text-2xl font-serif text-sand-200 leading-relaxed max-w-3xl mx-auto" data-id="element-94">
            <p data-id="element-95">Dolor físico que aparece una y otra vez.</p>
            <p data-id="element-96">Y aunque descanses… el cuerpo nunca termina de sentirse bien.</p>
            <p className="text-3xl sm:text-4xl font-bold text-white pt-4" data-id="element-97">
              ESO NO ES NORMAL.
            </p>
          </div>

          <p className="text-lg text-earth-300 max-w-2xl mx-auto" data-id="element-98">
            Tu cuerpo está sobrecargado. Y cuanto más tiempo pasa, más acumulás
            tensión, dolor y malestar físico.
          </p>
        </div>
      </section>

      {/* 4. Transformation Section */}
      <section className="py-20 px-4 bg-white" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          <div className="text-center mb-16" data-id="element-101">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-102">
              Este sistema es para vos si…
            </h2>
            <div className="w-24 h-1 bg-sage-500 mx-auto rounded-full" data-id="element-103"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 sm:gap-8" data-id="element-104">
            {[{
            icon: Activity,
            text: 'Te duele el cuerpo y no sabés por dónde empezar'
          }, {
            icon: Zap,
            text: "Vivís tomando analgésicos o esperando 'a que se pase'"
          }, {
            icon: Heart,
            text: 'Tenés tensión en cuello, espalda, mandíbula o cabeza'
          }, {
            icon: Moon,
            text: 'Dormís mal y te levantás sin energía'
          }, {
            icon: Brain,
            text: 'Sentís que tu cuerpo está siempre en alerta'
          }, {
            icon: Leaf,
            text: 'Querés herramientas simples para usar en casa'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 p-6 rounded-2xl bg-sand-50 border border-sand-100 hover:shadow-md transition-shadow" data-id="element-105">
                <div className="w-12 h-12 rounded-full bg-terracotta-100 flex items-center justify-center flex-shrink-0" data-id="element-106">
                  <item.icon className="w-6 h-6 text-terracotta-600" data-id="element-107" />
                </div>
                <p className="text-lg text-earth-800 font-medium pt-2" data-id="element-108">
                  {item.text}
                </p>
              </div>)}

            <div className="md:col-span-2 bg-sage-50 p-6 sm:p-8 rounded-2xl border border-sage-100 flex items-center gap-4 justify-center text-center" data-id="element-109">
              <Sparkles className="w-8 h-8 text-sage-600 flex-shrink-0 hidden sm:block" data-id="element-110" />
              <p className="text-xl font-serif font-medium text-sage-900" data-id="element-111">
                Necesitás una guía clara: qué punto tocar, dónde y por cuánto
                tiempo.
              </p>
            </div>
          </div>

          <div className="mt-16 flex justify-center" data-id="element-112">
            <ButtonCTA text="QUIERO EMPEZAR A SENTIRME MEJOR" data-id="element-113" />
          </div>
        </div>
      </section>

      {/* 5. Product Breakdown */}
      <section className="py-20 px-4 bg-sand-100 relative" data-id="element-114">
        <div className="max-w-6xl mx-auto space-y-20" data-id="element-115">
          <div className="text-center" data-id="element-116">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-117">
              ¿Qué incluye el Bundle?
            </h2>
            <p className="text-lg text-earth-600" data-id="element-118">
              Todo lo que necesitás para empezar hoy mismo.
            </p>
          </div>

          {/* Ebook 1 */}
          <div className="grid md:grid-cols-2 gap-12 items-center bg-white p-8 sm:p-12 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-119">
            <div className="order-2 md:order-1 space-y-6" data-id="element-120">
              <div className="inline-block px-4 py-1.5 bg-sage-100 text-sage-800 rounded-full text-sm font-bold tracking-wide" data-id="element-121">
                EBOOK 1
              </div>
              <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-122">
                Alivio en tus Manos
              </h3>
              <p className="text-xl text-earth-600 font-serif italic" data-id="element-123">
                Reflexología para aliviar dolor físico y recuperar el equilibrio
                del cuerpo
              </p>
              <p className="text-earth-800" data-id="element-124">
                Aprendé protocolos específicos para:
              </p>
              <ul className="grid sm:grid-cols-2 gap-3" data-id="element-125">
                {['Migrañas', 'Dolor cervical', 'Dolor lumbar', 'Contracturas', 'Estrés físico', 'Insomnio', 'Dolor menstrual', 'Ansiedad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-126">
                    <CheckCircle2 className="w-5 h-5 text-sage-500" data-id="element-127" /> {item}
                  </li>)}
              </ul>
            </div>
            <div className="order-1 md:order-2 flex items-center justify-center relative" data-id="element-128">
              <div className="absolute inset-0 bg-gradient-to-tr from-sage-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-129"></div>
              <img src="https://cdn.magicpatterns.com/uploads/pZnPaA6mBGpi2qvCE38CQs/ALIVIO_EN_TUS_MANOS.png" alt="Ebook Alivio en tus Manos — Reflexología" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[-3deg] hover:rotate-0 transition-transform duration-500" data-id="element-130" />
            </div>
          </div>

          {/* Ebook 2 */}
          <div className="grid md:grid-cols-2 gap-12 items-center bg-white p-8 sm:p-12 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-131">
            <div className="flex items-center justify-center relative" data-id="element-132">
              <div className="absolute inset-0 bg-gradient-to-tr from-terracotta-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-133"></div>
              <img src="https://cdn.magicpatterns.com/uploads/oqinBveycV1kdDYFdFy3sd/iculoterapia.png" alt="Ebook Puntos que Sanan — Auriculoterapia" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[3deg] hover:rotate-0 transition-transform duration-500" data-id="element-134" />
            </div>
            <div className="space-y-6" data-id="element-135">
              <div className="inline-block px-4 py-1.5 bg-terracotta-100 text-terracotta-800 rounded-full text-sm font-bold tracking-wide" data-id="element-136">
                EBOOK 2
              </div>
              <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-137">
                Puntos que Sanan
              </h3>
              <p className="text-xl text-earth-600 font-serif italic" data-id="element-138">
                Auriculoterapia práctica para desactivar síntomas físicos
                naturalmente
              </p>
              <p className="text-earth-800" data-id="element-139">
                Descubrí los puntos exactos del oído para trabajar:
              </p>
              <ul className="grid sm:grid-cols-2 gap-3" data-id="element-140">
                {['Dolor físico', 'Tensión muscular', 'Sistema nervioso', 'Estrés acumulado', 'Ansiedad física', 'Sueño y descanso', 'Inflamación'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-141">
                    <CheckCircle2 className="w-5 h-5 text-terracotta-500" data-id="element-142" />{' '}
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Bonus Stack */}
      <section className="py-20 px-4 bg-earth-900 text-sand-50 relative overflow-hidden" data-id="element-143">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-terracotta-900/30 rounded-full blur-[100px] pointer-events-none" data-id="element-144"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-145">
          <div className="text-center mb-16" data-id="element-146">
            <h2 className="text-3xl sm:text-5xl font-serif font-bold text-white mb-6" data-id="element-147">
              Además, si te sumás hoy te llevás{' '}
              <span className="text-gold-500" data-id="element-148">6 BONUS GRATIS</span>
            </h2>
            <p className="text-xl text-earth-300" data-id="element-149">
              Herramientas prácticas para potenciar tus resultados.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150">
            {[{
            num: 1,
            title: 'Ritual de Noche',
            desc: 'La rutina de 15 minutos para apagar la tensión física antes de dormir.',
            bullets: ['Rutina nocturna completa', 'Puntos para sueño profundo', 'Técnicas para bajar revoluciones']
          }, {
            num: 2,
            title: '21 Días para Sanar',
            desc: 'El plan progresivo para empezar a sentir cambios reales en tu cuerpo.',
            bullets: ['Calendario de 21 días', 'Prácticas de 5 a 15 min', 'Rutina para crear el hábito']
          }, {
            num: 3,
            title: 'Fichas de Sanación Rápida',
            desc: 'Qué punto tocar según el dolor o síntoma que tengas. Para alivio YA.',
            bullets: ['Migraña y dolor de cabeza', 'Ansiedad aguda e insomnio', 'Dolor lumbar y contracturas']
          }, {
            num: 4,
            title: 'Mapa Completo de Sanación',
            desc: 'Todos los puntos importantes de manos, pies y oído en un solo lugar.',
            bullets: ['Mapa de auriculoterapia', 'Mapa de manos y pies', 'Guía rápida visual']
          }, {
            num: 5,
            title: 'El Poder del Aroma',
            desc: 'Cómo combinar aceites esenciales con auriculoterapia y reflexología.',
            bullets: ['Aceites para dolor y ansiedad', 'Cómo diluirlos correctamente', 'Combinaciones por síntoma']
          }, {
            num: 6,
            title: 'Mi Diario de Sanación',
            desc: 'Registrá tu progreso y descubrí qué técnica funciona mejor para tu cuerpo.',
            bullets: ['Registro diario de síntomas', 'Escala de dolor', 'Tracker de constancia']
          }].map((bonus, i) => <div key={i} className="bg-earth-800/50 border border-earth-700 p-6 rounded-2xl hover:bg-earth-800 transition-colors" data-id="element-151">
                <div className="flex items-center gap-3 mb-4" data-id="element-152">
                  <div className="w-10 h-10 rounded-full bg-gold-500/20 text-gold-500 flex items-center justify-center font-bold" data-id="element-153">
                    <Gift className="w-5 h-5" data-id="element-154" />
                  </div>
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-155">
                    Bonus {bonus.num}
                  </h4>
                </div>
                <h5 className="text-lg font-bold text-sand-100 mb-2" data-id="element-156">
                  {bonus.title}
                </h5>
                <p className="text-earth-300 text-sm mb-4 h-12" data-id="element-157">{bonus.desc}</p>
                <ul className="space-y-2 mb-6" data-id="element-158">
                  {bonus.bullets.map((b, j) => <li key={j} className="text-sm text-earth-400 flex items-start gap-2" data-id="element-159">
                      <CheckCircle2 className="w-4 h-4 text-sage-500 flex-shrink-0 mt-0.5" data-id="element-160" />
                      {b}
                    </li>)}
                </ul>
                <div className="pt-4 border-t border-earth-700 flex justify-between items-center" data-id="element-161">
                  <span className="text-earth-400 text-sm line-through" data-id="element-162">
                    Valor: $11.990
                  </span>
                  <span className="text-gold-500 font-bold text-sm bg-gold-500/10 px-3 py-1 rounded-full" data-id="element-163">
                    HOY GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. Testimonials */}
      <section className="py-20 px-4 bg-sand-50" data-id="element-164">
        <div className="max-w-6xl mx-auto" data-id="element-165">
          <div className="text-center mb-16" data-id="element-166">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-167">
              Lo que dicen quienes ya lo probaron
            </h2>
            <div className="flex justify-center gap-1 text-gold-500" data-id="element-168">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-169" />)}
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-170">
            {[{
            name: 'Camila R.',
            text: 'Me bajó muchísimo la tensión del cuello. Lo empecé usando por curiosidad y ahora lo tengo guardado en el celular.'
          }, {
            name: 'Martina L.',
            text: 'Yo tenía dolor de cabeza casi todos los días. Las fichas rápidas me ayudaron a saber qué tocar sin tener que buscar mil videos.'
          }, {
            name: 'Julieta M.',
            text: 'El ritual de noche fue lo que más me sirvió. Me dormí más rápido y me levanté con menos pesadez en el cuerpo.'
          }, {
            name: 'Rocío V.',
            text: 'Me dio una sensación de control sobre mi cuerpo que no tenía. Antes solo esperaba a que se me pasara.'
          }, {
            name: 'Martín G.',
            text: 'Trabajo muchas horas frente a la compu y siempre terminaba con el cuello duro y dolor de cabeza. Empecé con los puntos del oído y en pocos días sentí la diferencia. Ya no necesito tomar tantos analgésicos.'
          }, {
            name: 'Diego F.',
            text: 'Lo compré medio escéptico, pero la verdad es que el ritual de noche me cambió el descanso. Me duermo más rápido y me levanto sin esa pesadez de siempre. Súper recomendable.'
          }].map((test, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-sand-100" data-id="element-171">
                <div className="flex text-gold-500 mb-4" data-id="element-172">
                  {[1, 2, 3, 4, 5].map(j => <Star key={j} className="w-4 h-4 fill-current" data-id="element-173" />)}
                </div>
                <p className="text-earth-700 italic mb-4" data-id="element-174">"{test.text}"</p>
                <p className="font-bold text-earth-900" data-id="element-175">— {test.name}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Warning & Offer Section */}
      <section className="py-20 px-4 bg-white relative" data-id="element-176">
        <div className="max-w-4xl mx-auto" data-id="element-177">
          {/* Warning Box */}
          <div className="bg-terracotta-50 border border-terracotta-200 p-8 sm:p-10 rounded-3xl text-center mb-16 shadow-sm" data-id="element-178">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-terracotta-700 mb-4" data-id="element-179">
              ⚠️ El cuerpo no se "acostumbra" al dolor. Se desgasta.
            </h3>
            <p className="text-lg text-earth-800 mb-2" data-id="element-180">
              Y cuanto más tiempo vivís con tensión, contracturas, cansancio y
              dolor físico, más normal se vuelve sentirte mal.
            </p>
            <p className="text-xl font-bold text-terracotta-600" data-id="element-181">
              No esperes a que el cuerpo te obligue a parar.
            </p>
          </div>

          {/* Value Stack & Offer */}
          <div className="bg-sand-100 rounded-[3rem] p-8 sm:p-12 border-4 border-white shadow-xl relative overflow-hidden" data-id="element-182">
            <div className="absolute top-0 right-0 w-32 h-32 bg-terracotta-500 rounded-bl-full -z-0 opacity-10" data-id="element-183"></div>

            <div className="relative z-10" data-id="element-184">
              <h3 className="text-3xl font-serif font-bold text-center text-earth-900 mb-8" data-id="element-185">
                Resumen de tu acceso hoy:
              </h3>

              <div className="space-y-3 mb-8 max-w-lg mx-auto" data-id="element-186">
                {[{
                name: 'Ebook Alivio en tus Manos',
                val: '$19.990'
              }, {
                name: 'Ebook Puntos que Sanan',
                val: '$19.990'
              }, {
                name: 'Bonus 1: Ritual de Noche',
                val: '$11.990'
              }, {
                name: 'Bonus 2: 21 Días para Sanar',
                val: '$11.990'
              }, {
                name: 'Bonus 3: Fichas Rápidas',
                val: '$11.990'
              }, {
                name: 'Bonus 4: Mapa Completo',
                val: '$11.990'
              }, {
                name: 'Bonus 5: El Poder del Aroma',
                val: '$11.990'
              }, {
                name: 'Bonus 6: Diario de Sanación',
                val: '$11.990'
              }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-sand-200 pb-2" data-id="element-187">
                    <span className="text-earth-800 flex items-center gap-2" data-id="element-188">
                      <CheckCircle2 className="w-4 h-4 text-sage-500" data-id="element-189" />{' '}
                      {item.name}
                    </span>
                    <span className="text-earth-500 line-through text-sm" data-id="element-190">
                      {item.val}
                    </span>
                  </div>)}
              </div>

              {/* Stock scarcity ribbon */}
              <div className="max-w-lg mx-auto mb-3 flex items-center justify-center gap-2 bg-earth-900 text-gold-500 text-sm font-bold uppercase tracking-wider rounded-full py-2 px-4" data-id="element-191">
                <Flame className="w-4 h-4 animate-pulse" data-id="element-192" />
                Solo quedan 14 cupos a este precio
              </div>

              <div className="text-center p-6 sm:p-10 rounded-3xl shadow-2xl mb-6 max-w-lg mx-auto relative overflow-hidden bg-gradient-to-br from-white via-blush-50 to-sand-100 border-4 border-double border-terracotta-300 ring-4 ring-gold-500/20" data-id="element-193">
                {/* Glow halo */}
                <div className="absolute -top-20 -left-20 w-48 h-48 bg-gold-500/30 rounded-full blur-3xl pointer-events-none" data-id="element-194"></div>
                <div className="absolute -bottom-20 -right-20 w-48 h-48 bg-terracotta-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-195"></div>

                {/* Discount ribbon — bigger */}
                <div className="absolute -top-1 -right-1 bg-gradient-to-br from-red-600 to-terracotta-700 text-white px-5 py-3 rounded-bl-3xl rounded-tr-3xl font-bold shadow-xl rotate-0 z-10" data-id="element-196">
                  <div className="text-2xl leading-none font-black" data-id="element-197">−82%</div>
                  <div className="text-[10px] tracking-wider mt-0.5" data-id="element-198">
                    DESCUENTO
                  </div>
                </div>

                <div className="relative z-10" data-id="element-199">
                  <p className="text-earth-500 font-medium text-sm uppercase tracking-wider mb-1 mt-2" data-id="element-200">
                    Valor total real:
                  </p>
                  <p className="text-3xl text-earth-400 line-through decoration-red-500 decoration-[3px] mb-5 font-bold" data-id="element-201">
                    $111.920 ARS
                  </p>

                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-terracotta-600 to-terracotta-700 text-white px-5 py-2 rounded-full text-sm font-bold mb-5 shadow-lg animate-pulse" data-id="element-202">
                    <Flame className="w-4 h-4 text-gold-500" data-id="element-203" />
                    PRECIO ESPECIAL — HOY
                    <Flame className="w-4 h-4 text-gold-500" data-id="element-204" />
                  </div>

                  <p className="text-earth-500 font-medium text-sm uppercase tracking-wider mb-1" data-id="element-205">
                    Hoy lo llevás por solo:
                  </p>
                  <div className="relative inline-block mb-3" data-id="element-206">
                    {/* Big animated price */}
                    <p className="text-7xl sm:text-8xl font-black leading-none bg-gradient-to-br from-terracotta-600 via-terracotta-700 to-earth-900 bg-clip-text text-transparent drop-shadow-sm tracking-tight" data-id="element-207">
                      $19.990
                    </p>
                    <span className="absolute -top-2 -right-10 sm:-right-12 text-xl sm:text-2xl font-bold text-earth-500" data-id="element-208">
                      ARS
                    </span>
                  </div>

                  <p className="text-earth-700 font-semibold mb-4" data-id="element-209">
                    Pago único · Acceso inmediato · Sin suscripciones
                  </p>

                  {/* Savings highlight - GOLD */}
                  <div className="bg-gradient-to-r from-gold-500/20 via-gold-500/30 to-gold-500/20 border-2 border-gold-500 rounded-2xl py-3 px-4 inline-flex items-center gap-2 shadow-md" data-id="element-210">
                    <span className="text-2xl" data-id="element-211">💰</span>
                    <div className="text-left" data-id="element-212">
                      <p className="text-xs text-earth-600 font-bold uppercase tracking-wide leading-none" data-id="element-213">
                        Te ahorrás hoy
                      </p>
                      <p className="text-2xl font-black text-earth-900 leading-none mt-0.5" data-id="element-214">
                        $91.930 ARS
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Live Countdown */}
              <div className="bg-earth-900 rounded-2xl p-5 mb-6 max-w-lg mx-auto text-center" data-id="element-215">
                <p className="text-gold-500 font-bold uppercase tracking-wider text-sm mb-3 flex items-center justify-center gap-2" data-id="element-216">
                  <Clock className="w-4 h-4 animate-pulse" data-id="element-217" /> Esta oferta
                  termina en:
                </p>
                <CountdownTimer data-id="element-218" />
                <p className="text-earth-400 text-xs mt-3" data-id="element-219">
                  Después vuelve al precio normal de $111.920
                </p>
              </div>

              <div className="max-w-lg mx-auto" data-id="element-220">
                <ButtonCTA text="QUIERO MI BUNDLE AHORA" subtext="🔒 Garantía 7 días • Compra 100% segura • Acceso de por vida" data-id="element-221" />
              </div>

              {/* 7-Day Money Back Guarantee Badge */}
              <div className="max-w-2xl mx-auto mt-8 bg-gradient-to-br from-sage-50 to-sand-50 border-2 border-sage-300 rounded-3xl p-6 sm:p-8 relative overflow-hidden" data-id="element-222">
                <div className="absolute -top-6 -right-6 w-32 h-32 bg-sage-100 rounded-full opacity-60" data-id="element-223"></div>
                <div className="flex flex-col sm:flex-row items-center gap-5 relative z-10" data-id="element-224">
                  {/* Guarantee Seal */}
                  <div className="relative flex-shrink-0" data-id="element-225">
                    <div className="w-28 h-28 rounded-full bg-gradient-to-br from-sage-500 to-sage-600 flex flex-col items-center justify-center text-white shadow-xl border-4 border-white" data-id="element-226">
                      <span className="text-3xl font-bold leading-none" data-id="element-227">7</span>
                      <span className="text-[10px] font-bold tracking-wider mt-0.5" data-id="element-228">
                        DÍAS
                      </span>
                      <span className="text-[9px] font-medium tracking-wide" data-id="element-229">
                        GARANTÍA
                      </span>
                    </div>
                    <Award className="absolute -top-2 -right-2 w-8 h-8 text-gold-500 fill-gold-500" data-id="element-230" />
                  </div>
                  <div className="text-center sm:text-left" data-id="element-231">
                    <p className="font-bold text-sage-900 text-xl sm:text-2xl font-serif mb-2" data-id="element-232">
                      Garantía de 7 días o te devolvemos tu dinero
                    </p>
                    <p className="text-earth-800 leading-relaxed" data-id="element-233">
                      Probá el bundle completo durante{' '}
                      <strong data-id="element-234">7 días sin riesgo</strong>. Si no te convence o
                      sentís que no es para vos, te devolvemos el 100% de tu
                      dinero. Sin preguntas. Sin vueltas. Sin letra chica.
                    </p>
                  </div>
                </div>
              </div>

              {/* Lifetime access (separate, secondary) */}
              <div className="max-w-lg mx-auto mt-4 flex items-center justify-center gap-2 text-sm text-earth-600" data-id="element-235">
                <ShieldCheck className="w-4 h-4 text-sage-600" data-id="element-236" />
                <span data-id="element-237">
                  Una vez que lo comprás, queda para vos para siempre.
                </span>
              </div>

              {/* Trust Row */}
              <div className="max-w-lg mx-auto mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center" data-id="element-238">
                {[{
                icon: Lock,
                label: 'Pago seguro'
              }, {
                icon: Download,
                label: 'Acceso inmediato'
              }, {
                icon: Award,
                label: 'Garantía 7 días'
              }, {
                icon: Heart,
                label: '+2.000 personas'
              }].map((t, i) => <div key={i} className="flex flex-col items-center gap-1" data-id="element-239">
                    <t.icon className="w-5 h-5 text-sage-600" data-id="element-240" />
                    <span className="text-xs text-earth-700 font-medium" data-id="element-241">
                      {t.label}
                    </span>
                  </div>)}
              </div>

              {/* Payment methods */}
              <div className="max-w-lg mx-auto mt-6 flex items-center justify-center gap-3 flex-wrap text-xs text-earth-500" data-id="element-242">
                <span data-id="element-243">Aceptamos:</span>
                {['Mercado Pago', 'Visa', 'Mastercard', 'Amex'].map(p => <span key={p} className="bg-white px-2.5 py-1 rounded border border-sand-200 font-semibold text-earth-700" data-id="element-244">
                    {p}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. FAQ Section */}
      <section className="py-20 px-4 bg-sand-50" data-id="element-245">
        <div className="max-w-4xl mx-auto" data-id="element-246">
          <div className="text-center mb-12" data-id="element-247">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-248">
              Preguntas Frecuentes
            </h2>
          </div>

          <FAQAccordion items={[{
          question: '¿Cuándo recibo el producto?',
          answer: 'Recibís el acceso inmediatamente después de la compra en tu correo electrónico.'
        }, {
          question: '¿Tengo garantía de devolución?',
          answer: 'Sí. Tenés 7 días desde tu compra para probar el bundle completo. Si no te convence o sentís que no es para vos, escribinos y te devolvemos el 100% de tu dinero. Sin preguntas, sin trabas, sin letra chica.'
        }, {
          question: '¿Necesito experiencia previa?',
          answer: 'No. Está pensado para empezar desde cero, con explicaciones claras y visuales.'
        }, {
          question: '¿Necesito agujas?',
          answer: 'No. La auriculoterapia de esta guía se trabaja con presión, manos y opciones simples como semillas auriculares.'
        }, {
          question: '¿Necesito comprar materiales?',
          answer: 'No obligatoriamente. Podés empezar solo con tus manos. Los aceites y semillas son opcionales.'
        }, {
          question: '¿Sirve solo para ansiedad?',
          answer: 'No. También está pensado para dolor físico, contracturas, migrañas, tensión, insomnio, agotamiento y molestias corporales.'
        }, {
          question: '¿Cuánto tiempo lleva cada práctica?',
          answer: 'La mayoría de las prácticas duran entre 5 y 15 minutos, ideales para integrar en tu día a día.'
        }, {
          question: '¿Lo puedo hacer desde el celular?',
          answer: 'Sí. Son PDFs digitales, podés leerlos desde celular, compu o tablet.'
        }, {
          question: '¿Puedo imprimirlo?',
          answer: 'Sí, especialmente los mapas, fichas rápidas y diario están diseñados para que puedas imprimirlos si lo deseás.'
        }, {
          question: '¿Esto reemplaza un médico?',
          answer: 'No. Es una herramienta complementaria de bienestar natural. Si tenés dolor intenso, persistente o síntomas graves, consultá con un profesional.'
        }, {
          question: '¿Tengo acceso para siempre?',
          answer: 'Sí. Una vez que lo comprás, queda para vos para siempre.'
        }]} data-id="element-249" />
        </div>
      </section>

      {/* 10. Final CTA Section */}
      <section className="py-24 px-4 bg-earth-900 text-center relative overflow-hidden" data-id="element-250">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-251"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-earth-900 via-earth-900/80 to-transparent" data-id="element-252"></div>

        <div className="max-w-3xl mx-auto relative z-10 space-y-8" data-id="element-253">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-sand-50" data-id="element-254">
            Tu cuerpo ya te viene avisando.
          </h2>

          <p className="text-xl text-earth-300" data-id="element-255">
            El dolor, la tensión, el cansancio y el insomnio no aparecen porque
            sí.
          </p>

          <p className="text-2xl font-serif text-sand-100 pb-4" data-id="element-256">
            Hoy podés seguir ignorándolo… o podés empezar a darle a tu cuerpo
            herramientas reales para aliviar, soltar y recuperarse.
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 max-w-xl mx-auto" data-id="element-257">
            <p className="inline-flex items-center gap-2 bg-gold-500 text-earth-900 px-4 py-1.5 rounded-full font-bold mb-4 text-sm uppercase tracking-wider" data-id="element-258">
              <Flame className="w-4 h-4" data-id="element-259" />
              Oferta por tiempo limitado
            </p>
            <p className="text-lg text-sand-200 mb-2" data-id="element-260">
              Accedé al bundle completo por solo:
            </p>
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-261">
              <span className="text-xl text-sand-300/70 line-through" data-id="element-262">
                $111.920
              </span>
              <span className="text-6xl sm:text-7xl font-black text-gold-500 leading-none" data-id="element-263">
                $19.990
              </span>
              <span className="text-lg text-sand-300" data-id="element-264">ARS</span>
            </div>
            <p className="text-sand-300 mb-6 text-sm" data-id="element-265">
              Pago único · Acceso inmediato
            </p>
            <ButtonCTA text="SÍ, QUIERO EL BUNDLE AHORA" className="!w-full" data-id="element-266" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-earth-950 text-earth-500 py-8 text-center text-sm" data-id="element-267">
        <p data-id="element-268">
          © {new Date().getFullYear()} Bienestar Digital. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-269">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier programa de bienestar.
        </p>
      </footer>

      {/* Floating urgency components */}
      <RecentPurchaseToast data-id="element-270" />
    </div>;
}